module.exports = __webpack_public_path__ + "static/img/08.1b11b357.png";